import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import QuickEntries from "@/pages/home/components/QuickEntries";
import LatestMediaSection from "@/pages/home/components/LatestMediaSection";
import TopicsSection from "@/pages/home/components/TopicsSection";
import NewsPreview from "@/pages/home/components/NewsPreview";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  usePageMeta({
    title: "91蜜桃 - 最新影视资源精选与资讯平台",
    description:
      "91蜜桃致力于为用户提供丰富的最新影视资源，包括电影、电视剧、综艺等内容分类，方便用户查看影视资讯及热门片单，满足多样观影需求。",
    keywords: "91蜜桃,影视资源,电影,电视剧,影视资讯,最新电影,热门电视剧,影视平台",
  });

  return (
    <div className="animate-fade-in">
      <HeroCarousel />
      <QuickEntries />
      <LatestMediaSection />
      <TopicsSection />
      <NewsPreview />
      <SiteIntro />
    </div>
  );
}